'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var BufferList = require('bl/BufferList');

module.exports = /*#__PURE__*/function () {
  var _fixedSizeChunker = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, options) {
    var bl, currentLength, emitted, maxChunkSize, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, buffer, newBl;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            bl = new BufferList();
            currentLength = 0;
            emitted = false;
            maxChunkSize = options.maxChunkSize;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 6;
            _iterator = _asyncIterator(source);

          case 8:
            _context.next = 10;
            return _awaitAsyncGenerator(_iterator.next());

          case 10:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 14;
            return _awaitAsyncGenerator(_step.value);

          case 14:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 29;
              break;
            }

            buffer = _value;
            bl.append(buffer);
            currentLength += buffer.length;

          case 19:
            if (!(currentLength >= maxChunkSize)) {
              _context.next = 26;
              break;
            }

            _context.next = 22;
            return bl.slice(0, maxChunkSize);

          case 22:
            emitted = true; // throw away consumed bytes

            if (maxChunkSize === bl.length) {
              bl = new BufferList();
              currentLength = 0;
            } else {
              newBl = new BufferList();
              newBl.append(bl.shallowSlice(maxChunkSize));
              bl = newBl; // update our offset

              currentLength -= maxChunkSize;
            }

            _context.next = 19;
            break;

          case 26:
            _iteratorNormalCompletion = true;
            _context.next = 8;
            break;

          case 29:
            _context.next = 35;
            break;

          case 31:
            _context.prev = 31;
            _context.t0 = _context["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 35:
            _context.prev = 35;
            _context.prev = 36;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 40;
              break;
            }

            _context.next = 40;
            return _awaitAsyncGenerator(_iterator.return());

          case 40:
            _context.prev = 40;

            if (!_didIteratorError) {
              _context.next = 43;
              break;
            }

            throw _iteratorError;

          case 43:
            return _context.finish(40);

          case 44:
            return _context.finish(35);

          case 45:
            if (!(!emitted || currentLength)) {
              _context.next = 48;
              break;
            }

            _context.next = 48;
            return bl.slice(0, currentLength);

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 31, 35, 45], [36,, 40, 44]]);
  }));

  function fixedSizeChunker(_x, _x2) {
    return _fixedSizeChunker.apply(this, arguments);
  }

  return fixedSizeChunker;
}();